import { render } from "./Musica.vue?vue&type=template&id=59d30bde&scoped=true"
import script from "./Musica.vue?vue&type=script&lang=js"
export * from "./Musica.vue?vue&type=script&lang=js"

import "./Musica.css?vue&type=style&index=0&id=59d30bde&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d30bde"]])

export default __exports__